export const baseURL = "https://backend.playerreel.io/";
export const feUrl = "https://player.reelapps.io/";


